import "./App.css";
import "./css/globle.css";
import { useRoutes, useLocation } from "react-router-dom";
import ErrorBoundary from "./components/ErrorBoundary";
import { LobbyRoutes } from "./routes/Routes";
import { SocketProvider } from "./context/SocketContext";
import { useEffect } from "react";
import { initGA, trackPageView } from "./utils/analytics";

function App() {
  const location = useLocation();
  const routes = useRoutes(LobbyRoutes);

  useEffect(() => {
    // Initialize Google Analytics
    initGA();
  }, []);

  useEffect(() => {
    // Track page views
    trackPageView(location.pathname);
  }, [location]);

  return (
    <div className="App">
      <ErrorBoundary>
        <SocketProvider>
          {routes}
        </SocketProvider>
      </ErrorBoundary>
    </div>
  );
}

export default App;
